import request from "@/router/axios.js";

//获取诊所下拉列表
export const getClinicList = (params) => {
  return request({
    url: "/api/ygj-chain/v1.0/clinic/select-all-list",
    method: "get",
    params: {
      ...params,
    },
  });
};

//员工的工作诊所
export const getClinicListbyEmp = (params) => {
  return request({
    url: "/api/ygj-chain/v1.0/clinic/select-emps-list",
    method: "get",
    params: {
      ...params,
    },
  });
};

//用于下拉选择员工的工作诊所和企微关联的门店
export const getClinicListByWecom = (params) => {
  return request({
    url: "/api/ygj-chain/v1.0/wecom/select-clinic",
    method: "GET",
    params,
  });
};

//根据门店ID集合获取门店：收费项目设置适用门店
export const getClinicListByIds = (ids) => {
  return request({
    url: "/api/ygj-chain/v1.0/clinic/list-by-ids",
    method: "post",
    data: {
      ids,
    },
  });
};

//企微-门店预约列表
export const getWecomAppointList = (params) => {
  return request({
    url: "/api/ygj-appoint/v1.0/wecom/list",
    method: "GET",
    params,
  });
};

// 企微-员工管理分页列表
export const getWecomUserPage = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-user/page",
    method: "get",
    params,
  });
};

// 当前门店对应企微关联的所有工作诊所部门企微员工（分页）
export const getWecomWorkplaceUserPage = (data) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-user/workplace-page",
    method: "POST",
    data,
  });
};

// 企微-部门树
export const getWecomDeptTree = (wecomId) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-department/tree",
    method: "get",
    params: {
      wecomId,
    },
  });
};

// 当前门店对应企微关联的工作诊所部门树
export const getWecomWorkplaceDeptTree = () => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-department/workplace-tree",
    method: "get",
  });
};

// 企微-员工列表（非分页，用于下拉）
export const getWecomEmployeeList = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-user/select-all-user",
    method: "get",
    params,
  });
};
